import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * ListTopContainmentSources
 *
 * Retrieves a list of top 25 sources by attribute.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const ListTopContainmentSources = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theQueryKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      headers: {
        'x-api-endpoint': `/dashboard/containment/top25/${thePayload?.date}`,
      },
      method: 'GET',
      params: { apiKey: theApiKey, queryKey: theQueryKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/Source/api/requests/queries/ListTopContainmentSources.js -> ListTopContainmentSources()',
      false,
      error
    );

    throw error;
  }
};
